import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PaginatorModule } from 'primeng/paginator';

export interface ActionUpdateVM{
  User: string;
  Note: string;
  Date: Date;
}

@Component({
  selector: 'app-action-updates',
  standalone: true,
  imports: [CommonModule, FormsModule, PaginatorModule],
  templateUrl: './action-updates.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './action-updates.component.scss'
})
export class ActionUpdatesComponent implements OnChanges {

  @Input() updates: ActionUpdateVM[] = [];
  @Input() saving: boolean = false;
  @Input() errorMessage: string = '';
  @Output() addUpdate = new EventEmitter<string>();

  public newUpdateText: string = '';
  public warn: boolean = false;
  public pageSize: number = 5;
  public pageIndex: number = 0;

  submit(){
    if (!this.newUpdateText || this.newUpdateText.trim().length === 0){
      this.warn = true;
      return;
    }
    this.warn = false;
    this.addUpdate.emit(this.newUpdateText.trim());
    this.newUpdateText = '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['updates']){
      this.pageIndex = 0;
    }
  }

  get pagedUpdates(): ActionUpdateVM[] {
    const start = this.pageIndex * this.pageSize;
    return this.updates.slice(start, start + this.pageSize);
  }

  onPageChange(event:any){
    this.pageIndex = event.page ?? 0;
    this.pageSize = event.rows ?? this.pageSize;
  }
}
